import { atom } from 'jotai'
import { Genre } from '../../Api/Lirari/Types/genre'

export const genresAtom = atom<Genre[]>([])
